var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ step: true, 'step--active': _vm.active }},[_c('div',{staticClass:"step__head"},[_c('div',{staticClass:"step__head-number"},[_vm._v("\n      "+_vm._s(_vm.number)+"\n    ")]),_vm._v(" "),_c('h2',{staticClass:"step__head-title"},[_vm._t("head")],2)]),_vm._v(" "),_c('div',{staticClass:"step__content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }